module.exports = __webpack_public_path__ + "static/8-e19d1d4592ca5398aa7abf4582c7d6cf.png";